import { jsx as _jsx } from "react/jsx-runtime";
import { CalendarDays, Layers } from "lucide-react";
import { NETWORK_ICON_MAP } from "../../../utils/networkConstants";
/**
 * Builder network key → the portal's network key in `networkConstants`, so the
 * builder shows the same brand artwork the Billing Summary and Performance
 * Tracker tables use instead of a look-alike lucide glyph.
 *
 * Email maps to Klaviyo because that is the collection the network reads
 * (`klaviyo_campaigns` / `klaviyo_flows`).
 */
const NETWORK_ASSET_KEY = {
    meta: "meta",
    google_ads: "adword",
    google_analytics: "ga",
    shopify: "shopify",
    email: "klaviyo",
    awin: "awin",
    impact: "impact",
    avantlink: "avantlink",
    cj: "cj",
    commission_factory: "commission_factory",
    costingtons: "costingtons",
    levanta: "levanta",
    pepperjam: "pepperjam",
    rakuten: "rakuten",
};
/** Network / field-group icon, e.g. the Meta glyph beside "Meta". */
export const GroupIcon = ({ group, size = 16, color, }) => {
    const assetKey = NETWORK_ASSET_KEY[group];
    const src = assetKey ? NETWORK_ICON_MAP[assetKey] : undefined;
    if (src) {
        // Brand artwork carries its own colours, so `color` is ignored here —
        // only the two generic groups below can be tinted.
        return (_jsx("img", { src: src, alt: "", "aria-hidden": true, style: {
                width: size,
                height: size,
                objectFit: "contain",
                display: "block",
                flex: "0 0 auto",
            } }));
    }
    const props = { size, color };
    switch (group) {
        case "time":
            return _jsx(CalendarDays, { ...props });
        case "common":
        default:
            return _jsx(Layers, { ...props });
    }
};
